import { z, type ZodType } from '@customerio/hydra-validation';
import type { UsersSideNavPreferences, UsersUserSettingsResponse } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

export type SideNavPreferences = UsersSideNavPreferences;

export interface UserSettings {
  accountId: number;
  userId: number;
  side_nav_preferences?: SideNavPreferences;
}

const SideNavItemPreferencesFromApi = z.looseObject({
  visibility: z.enum(['show', 'hide']),
});

const SideNavItemPreferenceMapFromApi = z.record(z.string(), SideNavItemPreferencesFromApi);

const SideNavEnvironmentPreferencesFromApi = z.looseObject({
  items: SideNavItemPreferenceMapFromApi.nullish(),
  object_types: SideNavItemPreferenceMapFromApi.nullish(),
});

const SideNavPreferencesFromApi = z.looseObject({
  environments: z.record(z.string(), SideNavEnvironmentPreferencesFromApi).nullish(),
  items: SideNavItemPreferenceMapFromApi.nullish(),
}) as unknown as ZodType<SideNavPreferences, unknown>;

const UserSettingsFromApi = z.looseObject({
  accountId: z.number(),
  userId: z.number(),
  side_nav_preferences: SideNavPreferencesFromApi.optional(),
}) as unknown as ZodType<UserSettings, unknown>;

export const userSettings = defineEntity<UserSettings, UserSettings, void, undefined, 'account'>({
  name: 'user-settings',
  scope: 'account',
  pk: (settings) => settings.userId,
  schema: { read: UserSettingsFromApi },
});

export const userSettingsKeys = userSettings.keys;

export function parseUserSettingsResponse(
  response: UsersUserSettingsResponse,
  context: Pick<UserSettings, 'accountId' | 'userId'>,
): UserSettings {
  return userSettings.parse({
    ...response.settings,
    accountId: context.accountId,
    userId: context.userId,
  });
}
